import Q21 from './Q21';

export default Q21;
